export default "__VITE_ASSET__ce7fb354__"